export const ERRORS_CODES_WITH_BACK_BUTTON = [404, 403];
